import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { injectIntl, defineMessages } from 'react-intl';
import { DayFilterEnum } from '../../../../constants';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.Availability.Title',
        defaultMessage: `{count, plural,
            =0 {availability}
            other {availability (#)}
        }`,
    },
    AnyDay: {
        id: 'Components.RefineSearch.Availability.AnyDay',
        defaultMessage: 'any day',
    },
    Today: {
        id: 'Components.RefineSearch.Availability.Today',
        defaultMessage: 'today',
    },
    Next3Days: {
        id: 'Components.RefineSearch.Availability.Next3Days',
        defaultMessage: 'next 3 days',
    },
});

const AvailabilityFilter = ({
    dayFilter,
    defaultOpen,
    intl,
    numApplied,
    onChangeCallback,
}) => {
    const title = intl.formatMessage(LOCALIZED_STRINGS.Title, {
        count: numApplied,
    });

    const anyDay = intl.formatMessage(LOCALIZED_STRINGS.AnyDay);
    const today = intl.formatMessage(LOCALIZED_STRINGS.Today);
    const next3Days = intl.formatMessage(LOCALIZED_STRINGS.Next3Days);

    const onChange = update => {
        if (update !== dayFilter) {
            onChangeCallback({ dayFilter: update });
        }
    };

    return (
        <CollapsibleSection
            data-test="search-refine-day-filter"
            defaultOpen={defaultOpen}
            headerText={title}
        >
            <RadioGroup
                flush
                name="availability"
                onChangeCallback={onChange}
                renderWithoutBox
                selectedValue={dayFilter || DayFilterEnum.AnyDay}
            >
                <Radio
                    data-test="search-refine-day-filter-anyday"
                    text={anyDay}
                    value={DayFilterEnum.AnyDay}
                />
                <Radio
                    data-test="search-refine-day-filter-today"
                    text={today}
                    value={DayFilterEnum.Today}
                />
                <Radio
                    data-test="search-refine-day-filter-next3days"
                    text={next3Days}
                    value={DayFilterEnum.Next3Days}
                />
            </RadioGroup>
        </CollapsibleSection>
    );
};

AvailabilityFilter.propTypes = {
    dayFilter: PropTypes.string.isRequired,
    defaultOpen: PropTypes.bool,
    numApplied: PropTypes.number,
    onChangeCallback: PropTypes.func.isRequired,
};

export default injectIntl(AvailabilityFilter);
